import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-slate-100 px-4 py-6 md:px-12 md:py-8" data-id="element-74" data-mp="4uqfz2u0sewh">
      <div className="flex gap-3 rounded-md border border-amber-400 bg-white p-3.5 md:p-5" data-id="element-75" data-mp="4x327s6t9bfc">
        <ShieldCheckIcon className="h-9 w-9 shrink-0 text-amber-500" strokeWidth={1.75} aria-hidden data-id="element-76" data-mp="9wphs8a433rb" />
        <div data-id="element-77" data-mp="er365qqcwamh">
          <h2 className="text-[17px] font-extrabold uppercase leading-[1.15] tracking-[-0.2px] text-blue-950 md:text-[21px]" data-id="element-78" data-mp="jsiubrntyx93">
            Tu compra está protegida
          </h2>
          <p className="mt-0.5 text-[12px] font-extrabold uppercase text-teal-700 md:text-[13px]" data-id="element-79" data-mp="ns1egl7tv4av">
            Garantía de devolución de dinero de 7 días
          </p>
          <div className="mt-1.5 space-y-1 text-[14px] leading-[1.4] text-slate-600 md:text-[15px]" data-id="element-80" data-mp="xim9jyoalqp1">
            <p data-id="element-81" data-mp="12klbr58aqhke">Explorá los seis volúmenes y los cinco bonos.</p>
            <p data-id="element-82" data-mp="17hljdkksnsdm">
              Si el material no cumple con tus expectativas, podés solicitar un reembolso dentro de los siete días
              posteriores a la compra, según la política de devoluciones de la tienda.
            </p>
          </div>
        </div>
      </div>
    </section>;
}